import { render, staticRenderFns } from "./paymentTerm.vue?vue&type=template&id=c0d52146&"
import script from "./paymentTerm.vue?vue&type=script&lang=js&"
export * from "./paymentTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0d52146')) {
      api.createRecord('c0d52146', component.options)
    } else {
      api.reload('c0d52146', component.options)
    }
    module.hot.accept("./paymentTerm.vue?vue&type=template&id=c0d52146&", function () {
      api.rerender('c0d52146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/paymentTerm.vue"
export default component.exports